/* oxlint-disable perfectionist/sort-imports */
import type UseI18nAddressInput from "../../cdn-reference/address_input.json";
import type UseI18nAdmin from "../../cdn-reference/admin.json";
import type UseI18nAdminLeadDetails from "../../cdn-reference/admin_lead_details.json";
import type UseI18nAffiliate from "../../cdn-reference/affiliate.json";
import type UseI18nAi from "../../cdn-reference/ai.json";
import type UseI18nAuth from "../../cdn-reference/auth.json";
import type UseI18nClient from "../../cdn-reference/client.json";
import type UseI18nCommonFe from "../../cdn-reference/common_fe.json";
import type UseI18nCompanyCard from "../../cdn-reference/company_card.json";
import type UseI18nCompanyRegistrationForm from "../../cdn-reference/company_registration_form.json";
import type UseI18nContactForm from "../../cdn-reference/contact_form.json";
import type UseI18nCustomer from "../../cdn-reference/customer.json";
import type UseI18nCustomerCampaigns from "../../cdn-reference/customer_campaigns.json";
import type UseI18nCustomerCreditManagement from "../../cdn-reference/customer_credit_management.json";
import type UseI18nCustomerCrmApi from "../../cdn-reference/customer_crm_api.json";
import type UseI18nCustomerFilters from "../../cdn-reference/customer_filters.json";
import type UseI18nCustomerFinancialDashboard from "../../cdn-reference/customer_financial_dashboard.json";
import type UseI18nCustomerLayout from "../../cdn-reference/customer_layout.json";
import type UseI18nCustomerLeadDetails from "../../cdn-reference/customer_lead_details.json";
import type UseI18nCustomerLeadOverview from "../../cdn-reference/customer_lead_overview.json";
import type UseI18nCustomerProjects from "../../cdn-reference/customer_projects.json";
import type UseI18nCustomerReviews from "../../cdn-reference/customer_reviews.json";
import type UseI18nCustomerSepaForm from "../../cdn-reference/customer_sepa_form.json";
import type UseI18nCustomerServices from "../../cdn-reference/customer_services.json";
import type UseI18nCustomerUpdates from "../../cdn-reference/customer_updates.json";
import type UseI18nCustomerWorkplace from "../../cdn-reference/customer_workplace.json";
import type UseI18nForms from "../../cdn-reference/forms.json";
import type UseI18nGeneral from "../../cdn-reference/general.json";
import type UseI18nInbox from "../../cdn-reference/inbox.json";
import type UseI18nInsulationTool from "../../cdn-reference/insulation_tool.json";
import type UseI18nMainSite from "../../cdn-reference/main_site.json";
import type UseI18nMainSiteAffiliate from "../../cdn-reference/main_site_affiliate.json";
import type UseI18nMainSiteBlog from "../../cdn-reference/main_site_blog.json";
import type UseI18nMainSiteBrochure from "../../cdn-reference/main_site_brochure.json";
import type UseI18nMainSiteCms from "../../cdn-reference/main_site_cms.json";
import type UseI18nMainSiteCompanyWall from "../../cdn-reference/main_site_company_wall.json";
import type UseI18nMainSiteCookies from "../../cdn-reference/main_site_cookies.json";
import type UseI18nMainSiteEnergyComparison from "../../cdn-reference/main_site_energy_comparison.json";
import type UseI18nMainSiteHomepage from "../../cdn-reference/main_site_homepage.json";
import type UseI18nMainSiteLayout from "../../cdn-reference/main_site_layout.json";
import type UseI18nMainSiteLeadThanks from "../../cdn-reference/main_site_lead_thanks.json";
import type UseI18nMainSiteProduct from "../../cdn-reference/main_site_product.json";
import type UseI18nMainSiteSearch from "../../cdn-reference/main_site_search.json";
import type UseI18nMySolvari from "../../cdn-reference/my_solvari.json";
import type UseI18nReviewForm from "../../cdn-reference/review_form.json";
import type UseI18nReviews from "../../cdn-reference/reviews.json";
import type UseI18nShared from "../../cdn-reference/shared.json";
import type UseI18nSolarPanelsYieldScan from "../../cdn-reference/solar_panels_yield_scan.json";
import type UseI18nUserSurveys from "../../cdn-reference/user_surveys.json";
import type UseI18nWaterHardnessTool from "../../cdn-reference/water_hardness_tool.json";

import { defineI18nMorpheus } from "../runtime/useI18n.ts";

const useI18nAddressInput =
  defineI18nMorpheus<typeof UseI18nAddressInput>("address_input.json");
const useI18nAdmin = defineI18nMorpheus<typeof UseI18nAdmin>("admin.json");
const useI18nAdminLeadDetails = defineI18nMorpheus<
  typeof UseI18nAdminLeadDetails
>("admin_lead_details.json");
const useI18nAffiliate =
  defineI18nMorpheus<typeof UseI18nAffiliate>("affiliate.json");
const useI18nAi = defineI18nMorpheus<typeof UseI18nAi>("ai.json");
const useI18nAuth = defineI18nMorpheus<typeof UseI18nAuth>("auth.json");
const useI18nClient = defineI18nMorpheus<typeof UseI18nClient>("client.json");
const useI18nCommonFe =
  defineI18nMorpheus<typeof UseI18nCommonFe>("common_fe.json");
const useI18nCompanyCard =
  defineI18nMorpheus<typeof UseI18nCompanyCard>("company_card.json");
const useI18nCompanyRegistrationForm = defineI18nMorpheus<
  typeof UseI18nCompanyRegistrationForm
>("company_registration_form.json");
const useI18nContactForm =
  defineI18nMorpheus<typeof UseI18nContactForm>("contact_form.json");
const useI18nCustomer =
  defineI18nMorpheus<typeof UseI18nCustomer>("customer.json");
const useI18nCustomerCampaigns = defineI18nMorpheus<
  typeof UseI18nCustomerCampaigns
>("customer_campaigns.json");
const useI18nCustomerCreditManagement = defineI18nMorpheus<
  typeof UseI18nCustomerCreditManagement
>("customer_credit_management.json");
const useI18nCustomerCrmApi = defineI18nMorpheus<typeof UseI18nCustomerCrmApi>(
  "customer_crm_api.json",
);
const useI18nCustomerFilters = defineI18nMorpheus<
  typeof UseI18nCustomerFilters
>("customer_filters.json");
const useI18nCustomerFinancialDashboard = defineI18nMorpheus<
  typeof UseI18nCustomerFinancialDashboard
>("customer_financial_dashboard.json");
const useI18nCustomerLayout = defineI18nMorpheus<typeof UseI18nCustomerLayout>(
  "customer_layout.json",
);
const useI18nCustomerLeadDetails = defineI18nMorpheus<
  typeof UseI18nCustomerLeadDetails
>("customer_lead_details.json");
const useI18nCustomerLeadOverview = defineI18nMorpheus<
  typeof UseI18nCustomerLeadOverview
>("customer_lead_overview.json");
const useI18nCustomerProjects = defineI18nMorpheus<
  typeof UseI18nCustomerProjects
>("customer_projects.json");
const useI18nCustomerReviews = defineI18nMorpheus<
  typeof UseI18nCustomerReviews
>("customer_reviews.json");
const useI18nCustomerSepaForm = defineI18nMorpheus<
  typeof UseI18nCustomerSepaForm
>("customer_sepa_form.json");
const useI18nCustomerServices = defineI18nMorpheus<
  typeof UseI18nCustomerServices
>("customer_services.json");
const useI18nCustomerUpdates = defineI18nMorpheus<
  typeof UseI18nCustomerUpdates
>("customer_updates.json");
const useI18nCustomerWorkplace = defineI18nMorpheus<
  typeof UseI18nCustomerWorkplace
>("customer_workplace.json");
const useI18nForms = defineI18nMorpheus<typeof UseI18nForms>("forms.json");
const useI18nGeneral =
  defineI18nMorpheus<typeof UseI18nGeneral>("general.json");
const useI18nInbox = defineI18nMorpheus<typeof UseI18nInbox>("inbox.json");
const useI18nInsulationTool = defineI18nMorpheus<typeof UseI18nInsulationTool>(
  "insulation_tool.json",
);
const useI18nMainSite =
  defineI18nMorpheus<typeof UseI18nMainSite>("main_site.json");
const useI18nMainSiteAffiliate = defineI18nMorpheus<
  typeof UseI18nMainSiteAffiliate
>("main_site_affiliate.json");
const useI18nMainSiteBlog = defineI18nMorpheus<typeof UseI18nMainSiteBlog>(
  "main_site_blog.json",
);
const useI18nMainSiteBrochure = defineI18nMorpheus<
  typeof UseI18nMainSiteBrochure
>("main_site_brochure.json");
const useI18nMainSiteCms =
  defineI18nMorpheus<typeof UseI18nMainSiteCms>("main_site_cms.json");
const useI18nMainSiteCompanyWall = defineI18nMorpheus<
  typeof UseI18nMainSiteCompanyWall
>("main_site_company_wall.json");
const useI18nMainSiteCookies = defineI18nMorpheus<
  typeof UseI18nMainSiteCookies
>("main_site_cookies.json");
const useI18nMainSiteEnergyComparison = defineI18nMorpheus<
  typeof UseI18nMainSiteEnergyComparison
>("main_site_energy_comparison.json");
const useI18nMainSiteHomepage = defineI18nMorpheus<
  typeof UseI18nMainSiteHomepage
>("main_site_homepage.json");
const useI18nMainSiteLayout = defineI18nMorpheus<typeof UseI18nMainSiteLayout>(
  "main_site_layout.json",
);
const useI18nMainSiteLeadThanks = defineI18nMorpheus<
  typeof UseI18nMainSiteLeadThanks
>("main_site_lead_thanks.json");
const useI18nMainSiteProduct = defineI18nMorpheus<
  typeof UseI18nMainSiteProduct
>("main_site_product.json");
const useI18nMainSiteSearch = defineI18nMorpheus<typeof UseI18nMainSiteSearch>(
  "main_site_search.json",
);
const useI18nMySolvari =
  defineI18nMorpheus<typeof UseI18nMySolvari>("my_solvari.json");
const useI18nReviewForm =
  defineI18nMorpheus<typeof UseI18nReviewForm>("review_form.json");
const useI18nReviews =
  defineI18nMorpheus<typeof UseI18nReviews>("reviews.json");
const useI18nShared = defineI18nMorpheus<typeof UseI18nShared>("shared.json");
const useI18nSolarPanelsYieldScan = defineI18nMorpheus<
  typeof UseI18nSolarPanelsYieldScan
>("solar_panels_yield_scan.json");
const useI18nUserSurveys =
  defineI18nMorpheus<typeof UseI18nUserSurveys>("user_surveys.json");
const useI18nWaterHardnessTool = defineI18nMorpheus<
  typeof UseI18nWaterHardnessTool
>("water_hardness_tool.json");

export {
  useI18nAddressInput,
  useI18nAdmin,
  useI18nAdminLeadDetails,
  useI18nAffiliate,
  useI18nAi,
  useI18nAuth,
  useI18nClient,
  useI18nCommonFe,
  useI18nCompanyCard,
  useI18nCompanyRegistrationForm,
  useI18nContactForm,
  useI18nCustomer,
  useI18nCustomerCampaigns,
  useI18nCustomerCreditManagement,
  useI18nCustomerCrmApi,
  useI18nCustomerFilters,
  useI18nCustomerFinancialDashboard,
  useI18nCustomerLayout,
  useI18nCustomerLeadDetails,
  useI18nCustomerLeadOverview,
  useI18nCustomerProjects,
  useI18nCustomerReviews,
  useI18nCustomerSepaForm,
  useI18nCustomerServices,
  useI18nCustomerUpdates,
  useI18nCustomerWorkplace,
  useI18nForms,
  useI18nGeneral,
  useI18nInbox,
  useI18nInsulationTool,
  useI18nMainSite,
  useI18nMainSiteAffiliate,
  useI18nMainSiteBlog,
  useI18nMainSiteBrochure,
  useI18nMainSiteCms,
  useI18nMainSiteCompanyWall,
  useI18nMainSiteCookies,
  useI18nMainSiteEnergyComparison,
  useI18nMainSiteHomepage,
  useI18nMainSiteLayout,
  useI18nMainSiteLeadThanks,
  useI18nMainSiteProduct,
  useI18nMainSiteSearch,
  useI18nMySolvari,
  useI18nReviewForm,
  useI18nReviews,
  useI18nShared,
  useI18nSolarPanelsYieldScan,
  useI18nUserSurveys,
  useI18nWaterHardnessTool,
};

export type {
  UseI18nAddressInput,
  UseI18nAdmin,
  UseI18nAdminLeadDetails,
  UseI18nAffiliate,
  UseI18nAi,
  UseI18nAuth,
  UseI18nClient,
  UseI18nCommonFe,
  UseI18nCompanyCard,
  UseI18nCompanyRegistrationForm,
  UseI18nContactForm,
  UseI18nCustomer,
  UseI18nCustomerCampaigns,
  UseI18nCustomerCreditManagement,
  UseI18nCustomerCrmApi,
  UseI18nCustomerFilters,
  UseI18nCustomerFinancialDashboard,
  UseI18nCustomerLayout,
  UseI18nCustomerLeadDetails,
  UseI18nCustomerLeadOverview,
  UseI18nCustomerProjects,
  UseI18nCustomerReviews,
  UseI18nCustomerSepaForm,
  UseI18nCustomerServices,
  UseI18nCustomerUpdates,
  UseI18nCustomerWorkplace,
  UseI18nForms,
  UseI18nGeneral,
  UseI18nInbox,
  UseI18nInsulationTool,
  UseI18nMainSite,
  UseI18nMainSiteAffiliate,
  UseI18nMainSiteBlog,
  UseI18nMainSiteBrochure,
  UseI18nMainSiteCms,
  UseI18nMainSiteCompanyWall,
  UseI18nMainSiteCookies,
  UseI18nMainSiteEnergyComparison,
  UseI18nMainSiteHomepage,
  UseI18nMainSiteLayout,
  UseI18nMainSiteLeadThanks,
  UseI18nMainSiteProduct,
  UseI18nMainSiteSearch,
  UseI18nMySolvari,
  UseI18nReviewForm,
  UseI18nReviews,
  UseI18nShared,
  UseI18nSolarPanelsYieldScan,
  UseI18nUserSurveys,
  UseI18nWaterHardnessTool,
};
